import { AllFreemiumProdSubData } from '@customTypes/ItemTypes';

interface setFreemiumProdDaysLeft {
    type: string;
    value: AllFreemiumProdSubData[];
}
export const FREEMIUM_PRODUCTS_DAYS_LEFT = 'FREEMIUM_PRODUCTS_DAYS_LEFT';
export function setFreemiumProdDaysLeft(value: AllFreemiumProdSubData[]): setFreemiumProdDaysLeft {
    return {
        type: FREEMIUM_PRODUCTS_DAYS_LEFT,
        value,
    };
}
